import { queryCustomers } from './service'

export const search = {
  inputs: [
    {
      type: 'InputCSRWithBalance',
      title: 'To CSR',
      span: 12,
      placeholder: 'Enter CSR Name',
      query: queryCustomers,
      getter: 'getters/search/csrId',
      setter: 'commit/search/setCsr',
      watch: 'state/search/csr',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Location',
      span: 6,
      placeholder: 'Warehouse Location',
      getter: 'state/search/tag4',
      setter: 'commit/search/setTag4',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Warehouse',
      span: 6,
      options: 'getters/warehosuesAll',
      getter: 'state/search/warehouse',
      setter: 'commit/search/setWarehouse',
      defaultValue: 0
    },
    {
      type: 'InputTextWithLocalSuggestions',
      title: 'Item Key',
      placeholder: 'Item Name or Helper Code',
      span: 6,
      // query: queryProducts,
      getter: 'state/search/product',
      setter: 'commit/search/setProduct',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Brands',
      span: 6,
      options: 'getters/brandsAll',
      getter: 'state/search/brand',
      setter: 'commit/search/setBrand',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Category',
      span: 6,
      options: 'getters/categoriesAll',
      getter: 'state/search/category',
      setter: 'commit/search/setCategory',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Stock Avl',
      span: 6,
      options: 'getters/stockAvlAll',
      getter: 'state/search/stockAvl',
      setter: 'commit/search/setStockAvl',
      defaultValue: 0
    }
  ],
  lines: [
    {
      prop: 'ColumnShow',
      label: 'Item Code',
      getter: 'code',
      width: 140,
      className: 'table-column-class-itemCode'
    },
    {
      prop: 'ColumnLocationDialog',
      label: 'Locations',
      width: 136,
      rowKey: 'tag4'
    },
    {
      prop: 'ColumnShow',
      label: 'Item Name',
      getter: 'name',
      width: 350,
      className: 'table-column-class-itemName'
    },
    // {
    //   prop: 'ColumnProductCodePopover',
    //   label: 'Item Name1',
    //   width: 350,
    //   rowKey: 'name'
    // },
    {
      prop: 'ColumnShow',
      label: 'TyrePro:KH / HYH:KU',
      getter: 'origin_code',
      width: 149,
      className: 'table-column-class-isOriginCode'
    },
    {
      prop: 'ColumnStockDropDown',
      label: 'Stock',
      width: 70,
      align: 'right',
      rowKey: 'stock'
    },
    // {
    //   prop: 'ColumnStockDropDownSingleStk',
    //   label: 'Main Stock',
    //   width: 95,
    //   align: 'right',
    //   rowKey: 'stock'
    // },
    // {
    //   prop: 'ColumnStockDropDownSingleStk',
    //   label: 'Sub Stock',
    //   width: 95,
    //   align: 'right',
    //   rowKey: 'stock'
    // },
    // {
    //   prop: 'model',
    //   label: 'Model',
    //   width: 155
    // },
    {
      prop: 'stock_3rdP',
      label: '3rdP Stk',
      width: 80,
      align: 'right'
    },
    {
      prop: 'classAPrice',
      label: 'A price',
      width: 78,
      align: 'right',
      className: 'table-column-class-type-color-new'
    },
    {
      prop: 'classBPrice',
      label: 'B price',
      width: 78,
      align: 'right',
      className: 'table-column-class-type-color'
    },
    {
      prop: 'specialPrice',
      label: 'Special',
      width: 80,
      align: 'right',
      className: 'table-column-sale-type-color'
    },
    {
      prop: 'standardPrice',
      label: 'VIP price',
      width: 74,
      align: 'right',
      className: 'table-column-sale-type-color'
    },
    {
      prop: 'classCPrice',
      label: 'C price',
      width: 65,
      align: 'right',
      className: 'table-column-ocop-type-color'
    },
    // {
    //   prop: 'classDPrice',
    //   label: 'D price',
    //   width: 65,
    //   align: 'right',
    //   className: 'table-column-ocop-type-color'
    // },
    // {
    //   prop: 'classEPrice',
    //   label: 'E price',
    //   width: 65,
    //   align: 'right',
    //   className: 'table-column-ocop-type-color'
    // },
    {
      prop: 'refPrice',
      label: 'Tempe',
      width: 62,
      align: 'right',
      className: 'table-column-cost-type-color'
    },
    {
      prop: 'costPrice',
      label: 'COST',
      width: 60,
      align: 'right',
      className: 'table-column-cost-type-color'
    },
    {
      prop: 'BillHistory',
      label: 'History',
      width: 73,
      align: 'center'
    },
    {
      prop: 'ColumnAddToCart',
      label: 'Add Cart',
      setter: 'actions/cart/addToCart',
      width: 172
    }
  ]
}

export default { search }
